<template>
  <transition name="fade">
    <div v-if="visible" class="openPopup">
      <div class="mask" />
      <div class="container">
        <div class="title">
          <img v-if="!iconHidden" :src="iconWarning" alt="icon" />
          {{ title }}
        </div>
        <div class="content">
          <div>{{ content }}</div>
        </div>
        <div class="btnRow">
          <span v-if="rightBtnText" @click="handleOpen">
            {{ rightBtnText }}
          </span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref } from 'vue';
import iconWarning from '@/assets/status-icons/warn-black.png';

const visible = ref(false);
const url = ref('');
const title = ref('提示');
const content = ref('请点击下方按钮打开支付页面');
const rightBtnText = ref('打开');
const iconHidden = ref(false);

function resetState() {
  visible.value = false;
  url.value = '';
  title.value = '提示';
  content.value = '请点击下方按钮打开支付页面';
  rightBtnText.value = '打开';
  iconHidden.value = false;
}

/**
 * 显示打开支付页弹窗
 * @param {string|boolean|object|null} options url 或配置项；false / '' / null 关闭
 */
function showOpen(options) {
  if (!options) {
    resetState();
    return;
  }

  if (typeof options === 'string') {
    url.value = options;
  } else {
    url.value = options.url || '';
    if (options.title != null) title.value = options.title;
    if (options.content != null) content.value = options.content;
    if (options.rightBtnText != null) rightBtnText.value = options.rightBtnText;
    if (options.iconHidden != null) iconHidden.value = options.iconHidden;
  }

  if (!url.value) {
    return;
  }

  visible.value = true;
}

function handleOpen() {
  if (url.value) {
    window.open(url.value, '_blank');
  }
  resetState();
}

defineExpose({ showOpen });
</script>

<style lang="less" scoped>
.openPopup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;

  > .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  > .container {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 3.42rem;
    border-radius: 0.16rem;
    background: linear-gradient(180deg, #e1f0fe 0%, #fff 34.89%);
    padding: 0.22rem 0.3rem 0.3rem 0.3rem;
    z-index: 2;

    > .title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.16rem;
      line-height: 0.27rem;
      text-align: center;
      font-weight: 500;
      color: #2a2a2a;
      font-size: 0.18rem;

      > img {
        width: 0.18rem;
        height: 0.18rem;
        margin-right: 0.08rem;
      }
    }

    > .content {
      display: flex;
      flex-direction: column;
      line-height: 0.24rem;
      color: #2a2a2a;
      font-size: 0.16rem;
      font-weight: 400;
      margin-bottom: 0.22rem;

      > div {
        text-align: center;
      }
    }

    .btnRow {
      display: flex;
      align-items: center;
      justify-content: center;

      > span {
        width: 1.36rem;
        height: 0.5rem;
        border-radius: 0.08rem;
        background: linear-gradient(90deg, #5b77ef 0%, #3d40e9 100%);
        color: #fff;
        text-align: center;
        line-height: 0.5rem;
        font-size: 0.16rem;
        font-weight: 500;
      }
    }
  }
}

.fadeEnterActive,
.fadeLeaveActive {
  transition: opacity 0.3s;
}

.fadeEnter,
.fadeLeaveTo {
  opacity: 0;
}
</style>
